module.exports = __webpack_public_path__ + "static/media/if_male_628288.43b0f617.svg";